import { useUsersQuery } from './useUsersQuery';
import { useUsersSearch } from './useUsersSearch';
import { columns } from '../tables/columns';
import { useParams } from 'react-router-dom';

export const useUsers = (filters: Record<string, string> = {}) => {
    const { id: accountId } = useParams();

    // Separate client-side filters from server-side filters (UsersFilterInput only supports email, sub, accountId)
    const { status, ...serverFilters } = filters;

    // Merge accountId from route params into server filters
    const mergedFilters = accountId ? { ...serverFilters, accountId } : serverFilters;

    const { data: items = [], isLoading: loading } = useUsersQuery(mergedFilters);
    const { keyword } = useUsersSearch();

    // Client-side filtering for keyword and status
    const visibleItems = items.filter(item => {
        if (keyword &&
            !item.name?.toLowerCase().includes(keyword.toLowerCase()) &&
            !item.email?.toLowerCase().includes(keyword.toLowerCase()) &&
            !item.username?.toLowerCase().includes(keyword.toLowerCase())) {
            return false;
        }
        if (status && item.status !== status) {
            return false;
        }
        return true;
    });

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
